<template>
  <button
    type="button"
    class="lk-burger-btn"
    :class="{ 'lk-burger-btn--open': value }"
    :aria-expanded="value ? 'true' : 'false'"
    @click="toggle"
  >
    <span class="lk-burger-btn__line lk-burger-btn__line--top" />
    <span class="lk-burger-btn__line lk-burger-btn__line--middle" />
    <span class="lk-burger-btn__line lk-burger-btn__line--bottom" />
  </button>
</template>

<script>
export default {
  name: 'BurgerBtn',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value)
    },
  },
}
</script>

<style lang="sass">
@import "~@src/assets/lk/styles/variables"

.lk-burger-btn
  position: relative
  display: inline-flex
  align-items: center
  justify-content: center
  vertical-align: middle
  width: 40px
  height: 40px
  padding: 0
  border: 0
  background: transparent
  cursor: pointer
  appearance: none

  &:hover
    .lk-burger-btn__line
      background-color: $bright-blue

      @media (max-width: $header-screen-md)
        background-color: $white

  &__line
    position: absolute
    left: 9px
    width: 22px
    height: 2px
    background-color: #fff
    border-radius: 2px
    transition: background-color 0.3s, top 0.3s ease 0.3s, transform 0.3s ease 0s
    transform-style: preserve-3d
    will-change: background-color, top, transform

    &--top
      top: 12px

    &--middle
      top: calc(50% - 1px)

    &--bottom
      top: calc(100% - 14px)

  &--open
    .lk-burger-btn__line
      &--top
        top: calc(50% - 1px)
        transform: rotate(45deg)
        transition: background-color 0.3s, top .3s ease 0s, transform .3s ease .3s

      &--middle
        opacity: 0

      &--bottom
        top: calc(50% - 1px)
        transform: rotate(-45deg)
        transition: background-color 0.3s, top .3s ease 0s, transform .3s ease .3s
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/lk/header/components/LkBurgerBtn.vue